var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('h1',{staticClass:"text-center"},[_vm._v("Inscription")]),_c('UserForm',{attrs:{"user":{},"persist":_vm.SaveUser()}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('a',{attrs:{"href":"/"}},[_vm._v("Retour à la connexion")])])
}]

export { render, staticRenderFns }